import { Suspense } from "react";
import Termoscondicoes from "../../components/Termoscodincoes";

export default function TermsPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Termoscondicoes />
    </Suspense>
  );
}
